import { render, staticRenderFns } from "./store_buy.vue?vue&type=template&id=cdfc219e"
import script from "./store_buy.vue?vue&type=script&lang=js"
export * from "./store_buy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports